const onReady = (callback) => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
        return;
    }

    callback();
};

const initNav = () => {
    const dropdownMenus = document.querySelectorAll('.dropdown-menu');
    const listingHeader = document.querySelector('.listing-header');

    if (listingHeader && dropdownMenus.length) {
        const toggleSelected = (isActive) => {
            dropdownMenus.forEach((menu) => {
                menu.classList.toggle('selected', isActive);
            });
        };

        listingHeader.querySelectorAll('li.sub-menu a').forEach((link) => {
            link.addEventListener('mouseenter', () => toggleSelected(true));
            link.addEventListener('mouseleave', () => toggleSelected(false));
        });
    }

    const sideNav = document.querySelector('#mySidenav');
    const openButton = document.querySelector('[data-nav-open]');
    const closeButton = document.querySelector('[data-nav-close]');

    if (sideNav) {
        const openNav = () => {
            sideNav.style.width = '100%';
        };

        const closeNav = () => {
            sideNav.style.width = '0';
        };

        if (openButton) {
            openButton.addEventListener('click', (event) => {
                event.preventDefault();
                openNav();
            });
        }

        if (closeButton) {
            closeButton.addEventListener('click', (event) => {
                event.preventDefault();
                closeNav();
            });
        }
    }

    document.querySelectorAll('.arrowBtn').forEach((button) => {
        button.addEventListener('click', () => {
            const dropdownContent = button.closest('.dropdown')?.querySelector('.dropdown-content');

            if (!dropdownContent) {
                return;
            }

            dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
        });
    });
};

export default () => onReady(initNav);
